//update not working with api
import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  MenuItem,
  TextField,
  Typography,
  TextareaAutosize,
  Table,
} from "@mui/material";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api from "../../../utils/Url";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getISTDate } from "../../../utils/Constant";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
import api2 from "../../../utils/Url2";
type Props = {};
const VehicleTypeInfoEdit = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { defaultValues } = getISTDate();
  const [lang, setLang] = useState<Language>("en");
  const location = useLocation();
  console.log("loation", location)
  const [toaster, setToaster] = useState(false);
  const initialRowData = {
    id: 0,
    vehicleTypeId: 0,
    petroId: 0,
    sessionD1: 0,
    sessionD2: 0,
    petroName: "",
    createdOn: defaultValues,
    effectiveDate: defaultValues,
    updateOn: defaultValues,
    createdBy: "",
    updatedBy: "",
    ntRecord: ""
  };
  const [petrolOption, setpetrolOption] = useState([
    { value: -1, label: t("text.id") },
  ]);
  const [vehicleOption, setvehicleOption] = useState([
    { value: -1, label: t("text.vehicleTypeId") },
  ]);

  useEffect(() => {
    getVehicleData();
    getpetrolData();
  }, []);
  const getVehicleData = async () => {
    const collectData = {
      "vehicleTypeId": -1,
      "vehicleTypename": ""
    };
    const response = await api.post(`VehicleType/GetVehicleType`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["vehicleTypename"],
        value: data[index]["vehicleTypeId"],
      });
    }
    setvehicleOption(arr);
  };

  const getpetrolData = async () => {
    const collectData = {
      "id": -1,
      "petroPump": "",
      "cityId": 0,
      "stateId": 0
    };
    const response = await api.post(`PetrolPump/GetPetrolPump`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["petroPump"],
        value: data[index]["id"],
      });
    }
    setpetrolOption(arr);
  };
  const formik = useFormik({
    initialValues: {
      id: location.state.id,
      vehicleTypeId: location.state.vehicleTypeId,
      petroId: location.state.petroId,
      sessionD1: location.state.sessionD1,
      sessionD2: location.state.sessionD2,
      petroName: location.state.petroName,
      createdOn: defaultValues,
      effectiveDate: defaultValues,
      updateOn: defaultValues,
      createdBy: "",
      updatedBy: "",
      ntRecord: ""
    },
    onSubmit: async (values) => {
      const response = await api.post(`Vtypeinfo/AddUpdateVtypeinfo`, values);
      if (response.data.status === 1) {
        setToaster(false);
        toast.success(response.data.message);
        navigate("/vehiclemanagement/vehicletypeinfo");
      } else {
        setToaster(true);
        toast.success(response.data.message);
      }
    },
  });
  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.VehicleTypeInfoEdit")}
          </Typography>
          <Grid container justifyContent="flex-end">
            <Grid item lg={2} md={2} xs={12} marginTop={2}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>




              {/* <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.PetrolPumpName")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="petroName"
                  id="petroName"
                  value={formik.values.petroName}

                  placeholder={t("text.PetrolPumpName")}
                  onChange={formik.handleChange}
                />
              </Grid> */}

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.EffectiveDate")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="effectiveDate"
                  id="effectiveDate"
                  type="date"
                  value={formik.values.effectiveDate}
                  placeholder={t("text.EffectiveDate")}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"

                  options={vehicleOption}
                  value={
                    vehicleOption.find(
                      (option) =>
                        option.value ===
                        formik.values.vehicleTypeId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("VehicleTypeName", newValue?.label);
                    formik.setFieldValue("vehicleTypeId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.VehicleTypeName")} />}
                    />
                  )}
                />
              </Grid>

              {/* <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={vehicleOption}
                  value={
                    petrolOption.find(
                      (option) =>
                        option.value ===
                        formik.values.vehicleTypeId
                    ) || null
                  }
                
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("VehicleTypeName", newValue?.label);
                    formik.setFieldValue("vehicleTypeId", newValue?.value?.toString());
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.VehicleTypeName")} />}
                    />
                  )}
                />
              </Grid> */}



              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.Shift1")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="sessionD1"
                  id="sessionD1"
                  type="number"
                  value={formik.values.sessionD1}
                  placeholder={t("text.Shift1")}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.Shift2")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="sessionD2"
                  id="sessionD2"
                  type="number"
                  value={formik.values.sessionD2}
                  placeholder={t("text.Shift2")}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"

                  options={petrolOption}
                  value={
                    petrolOption.find(
                      (option) =>
                        option.value ===
                        formik.values.petroId
                    ) || null
                  }

                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("petroName", newValue?.label);
                    formik.setFieldValue("petroId", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.PetrolPump")} />}
                    />
                  )}
                />
              </Grid>


              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.update")}
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default VehicleTypeInfoEdit;